import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(main)/components/CourseMasterPage/page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(main)/components/CustomCategory/CustomCategory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureProductWithTabs"] */ "/app/src/app/(main)/components/FeatureProduct/FeatureProductWithTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FlashSaleComponentView"] */ "/app/src/app/(main)/components/flash-sale.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroClient"] */ "/app/src/app/(main)/components/Hero/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsMotion"] */ "/app/src/app/(main)/components/News/NewsMotion.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/common/ZaloPhoneFloating.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/bhhChat/BHHChat.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingOverlay"] */ "/app/src/components/loading-overlay.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/image-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Navbar/components/NavbarClientVer2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider"] */ "/app/src/components/ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/app/src/context/cart-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingProvider"] */ "/app/src/context/loading-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/provider/cookie-provider-wrapper.tsx");
